import { useMemo } from 'react';

export interface UsePropertyTypeOptions {
  propertyType: string | null;
}

export interface UsePropertyTypeResult {
  formatted: string | null;
  hasValue: boolean;
}

/**
 * Hook for formatting property type display.
 * 
 * Currently passes through the seoType directly, but provides
 * a consistent interface for future formatting needs.
 */
export function usePropertyType({ propertyType }: UsePropertyTypeOptions): UsePropertyTypeResult {
  return useMemo(() => ({
    formatted: propertyType || null,
    hasValue: !!propertyType,
  }), [propertyType]);
}
